<template>
  <div>
    <agile-table
    :data-type="'priceListCustomer'"
    :table-meta="tableMeta"
    :data="priceListCustomer"
    :filter-meta="filterMeta"
    :action-meta="actionMeta"
    :column-meta="columnMeta"
    @rowAction="rowAction"
    @fieldAction="fieldAction" />
    <new-button @clicked="openPriceListCustomerModal(0)" />
    <slideout-panel />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import PriceListCustomerModal from '@/components/modals/PriceListCustomerModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    PriceListCustomerModal,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-list-ol'
      },

      filterMeta: [{
        fieldId: 'customerName',
        type: 'string',
        label: 'Kund'
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'customerName',
          label: 'Kund'
        },
        {
          fieldId: 'comment',
          label: 'Kommentar'
        },
        {
          fieldId: 'numberOfLines',
          label: 'Antal priser definierade',
          disableOrdering: true
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updatePriceList',
          iconClass: 'fal fa-pen'
        },
        {
          label: 'Ta bort',
          action: 'deletePriceList',
          iconClass: 'fal fa-trash-alt'
        }]
      }
    }
  },
  watch: {
    'priceListCustomer.filter': {
      handler () {
        this.priceListCustomer.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      priceListCustomer: state => state.priceListCustomer.all
    })
  },
  methods: {
    ...mapActions('priceListCustomer', ['initialize', 'getListData', 'delete']),

    rowAction (action, priceList) {
      switch (action) {
        case 'updatePriceList':
          this.openPriceListCustomerModal(priceList.customerId)
          break
        case 'deletePriceList':
          this.$confirm('Radera kundprislista', 'Är du säker på att du vill radera kundprislistan?').then((result) => {
            if (result.value) {
              this.delete(priceList.customerId)
            }
          })
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, user) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openPriceListCustomerModal (id) {
      this.$panel(PriceListCustomerModal, { id })
    }
  },

  created () {
    this.initialize()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/SuperAdmin/PriceListsCustomerPage.vue